import React from 'react'
import cn from 'clsx'
import { rem } from 'polished'
import styled from 'styled-components'
import Group from 'components/utils/Group'
import PriceRowPrice from 'components/Luxkit/PricePoints/PriceRowPrice'
import PriceRowLuxPlusNonMemberPrice from 'components/Luxkit/PricePoints/LuxPlus/PriceRowLuxPlusNonMemberPrice'
import PriceRowLuxPlusPrice from 'components/Luxkit/PricePoints/LuxPlus/PriceRowLuxPlusPrice'
import Caption from 'components/Luxkit/Typography/Caption'
import { mediaQueryUp } from 'components/utils/breakpoint'

const FadingElement = styled.div`
  display: none;
  min-width: ${rem(120)};

  &.visible {
    display: block;
  }

  ${mediaQueryUp.tablet} {
    display: block;
    opacity: 0;
    transition: opacity 0.2s;
    pointer-events: none;

    &.visible {
      display: block;
      opacity: 1;
      pointer-events: auto;
    }
  }
`

interface Props {
  totalPrice: number;
  totalMemberPrice: number;
  isFromPrice: boolean;
  ticketUnitLabel: string;
  discountPercentage?: number;
  isLuxPlusOffer: boolean;
}

function ExperienceBookingModalPrices(props: Props) {
  const {
    totalPrice,
    totalMemberPrice,
    isFromPrice,
    ticketUnitLabel,
    discountPercentage,
    isLuxPlusOffer,
  } = props

  if (isLuxPlusOffer) {
    return (
      <Group direction="vertical" gap={0}>
        <FadingElement as={Caption} className={cn({ visible: isFromPrice })} variant="medium" colour="neutral-two">
          From
        </FadingElement>
        <PriceRowLuxPlusPrice
          logoPlacement="trailing"
          size="L"
          memberPrice={totalMemberPrice}
          saleUnit={isFromPrice ? ticketUnitLabel : 'total'}
          discountPercentage={discountPercentage}
          discountType="estimate"
        />
        <PriceRowLuxPlusNonMemberPrice
          size="M"
          nonMemberPrice={totalPrice}
        />
      </Group>
    )
  }

  return (
    <>
      <FadingElement as={Caption} className={cn({ visible: isFromPrice })} variant="medium" colour="neutral-three">
        From
      </FadingElement>
      <PriceRowPrice
        size="L"
        price={totalPrice}
        saleUnit={isFromPrice ? ticketUnitLabel : 'total'}
        discountPercentage={discountPercentage}
        discountType="estimate"
      />
    </>
  )
}

export default ExperienceBookingModalPrices
